import React from "react";
import { useContext } from "../../../context";

export function CancelForAdditionalProvider() {
  const { modals } = useContext();

  const onCancel = () => {
    modals.confirmCancel.open({ isAdditionalProvider: true });
  };

  return (
    <button className="new-red-btn" onClick={onCancel}>
      Remove Additional Provider
    </button>
  );
}
